// extracted by mini-css-extract-plugin
module.exports = {"iconswithtable":"button_iconswithtable__3nFja"};